export enum PriorityLevel {
  PRIORITY_HIGH = 'PRIORITY_HIGH',
  PRIORITY_NORMAL = 'PRIORITY_NORMAL',
  PRIORITY_LOW = 'PRIORITY_LOW',
}
